import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {NgWaitModule} from "../../ng-shared/ng-components/ng-wait/ng-wait.module";
import {TciTenantModule} from "../../ng-tenant/tci-tenant.module";

import {NgAppCreateV2Component} from "./ng-app-create-v2.component";
import {
    TCICreateTenantAppChooserDynLoaderV2Component,
    TCICreateTenantAppDetailDynLoaderV2Component,
    TCICreateTenantAppImportDynLoaderV2Component,
    TCICreateTenantAppGraphQLImportDynLoaderV2Component,
    TCICreateTenantAppMarketplaceDynLoaderV2Component
} from "./base-components/index";

import {NgAppListService} from "../ng-app-list.service";
import {NgModelerService} from "./../../ng-shared/ng-services/ng-ws-modeler.service";

import {PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import { TooltipModule } from "primeng/primeng";


@NgModule({
    imports: [
        CommonModule,
        PerfectScrollbarModule,
        NgWaitModule,
        TciTenantModule,
        TooltipModule
    ],
    declarations: [
        NgAppCreateV2Component,
        TCICreateTenantAppDetailDynLoaderV2Component,
        TCICreateTenantAppImportDynLoaderV2Component,
        TCICreateTenantAppChooserDynLoaderV2Component,
        TCICreateTenantAppGraphQLImportDynLoaderV2Component,
        TCICreateTenantAppMarketplaceDynLoaderV2Component
    ],
    providers: [
        NgAppListService,
        NgModelerService
    ],
    exports: [
        NgAppCreateV2Component
    ]
})
export class NgAppCreateV2Module {
}
